export default {
  path: '/product_type_files',
  name: 'product_type_files',
  component: () => import('../components/producttypefile/Layout'),
  redirect: { name: 'ProducttypefileList' },
  meta: {
    breadcrumb: 'qualitycheck.product.producttypefiles',
  },
  children: [
    {
      name: 'ProducttypefileList',
      path: '',
      component: () => import('../views/producttypefile/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    /*
    {
      name: 'ProducttypefileCreate',
      path: 'new',
      component: () => import('../views/producttypefile/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    */
    {
      name: 'ProducttypefileUpdate',
      path: ':id/edit',
      component: () => import('../views/producttypefile/Update'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefile',
      },
    },
    {
      name: 'ProducttypefileShow',
      path: ':id',
      component: () => import('../views/producttypefile/Show'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefile',
      },
    }
  ]
};
